import React from 'react';

import {asClassComponent} from '/util/hoc.util';

import {NavigationContext} from './NavigationProvider';

export default (Component: any) =>
  asClassComponent((props: any) => (
    <NavigationContext.Consumer>
      {navigationProps => <Component {...props} {...navigationProps} />}
    </NavigationContext.Consumer>
  ));
